import { MemberCard } from "../models/Person/MemberCard";
import { useUtility } from "@/composables/useUtility";

export const memberCardMapper = (card: PersonsCardsDTO): MemberCard => {
  return new MemberCard({
    id: card.assignId,
    cardNumber: card.cardNum,
    dateIssued: card.issueDate,
    status: card.active != false,
    paid: card.paid === "Y" ? true : false,
  });
};

// export const memberCardUnMapper = (card: MemberCard) => {
//   const { unMapFalseyValue } = useUtility();

//   return {

//   }
// };

/**
 * type PersonsCardsDTO = {
  assignId: number | null;
  personId?: number | null;
  issueDate: string | null;
  createdOn?: string | null;
  createdBy?: string | null;
  updatedOn?: string | null;
  updatedBy?: string | null;
  cardNum: string | null;
  temp: string | null;
  active?: string | null;
  ccTransNum?: number | null;
  paymentMedium?: string | null;
  price?: number | null;
  closeId?: number | null;
  paid?: string | null;
  voidCloseId?: number | null;
  nonce?: string | null;
};
 */
